export var TableCellContentType;
(function (TableCellContentType) {
    TableCellContentType["CHECKBOX"] = "CHECKBOX";
    TableCellContentType["ACTION"] = "ACTION";
    TableCellContentType["LOADING"] = "LOADING";
    TableCellContentType["GROUP_HEADER"] = "GROUP_HEADER";
    TableCellContentType["SPACER"] = "SPACER";
    TableCellContentType["NO_PADDING"] = "NO_PADDING";
})(TableCellContentType || (TableCellContentType = {}));
